module.exports = __webpack_public_path__ + "img/63ad4e2.png";